import React from 'react';

const Mail = () => (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.8 1.04761H17.2C18.19 1.04761 19 1.83511 19 2.79761V13.2976C19 14.2601 18.19 15.0476 17.2 15.0476H2.8C1.81 15.0476 1 14.2601 1 13.2976V2.79761C1 1.83511 1.81 1.04761 2.8 1.04761Z"
      stroke="#6A6A6A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 2.79761L10 8.92261L1 2.79761"
      stroke="#6A6A6A"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default Mail;
